import axios from "../../../config/axiosConfig";

export const getReporteImpuestos = ({ fechaIni, fechaFin, sucursal }) =>
  axios.get("/api/reporte-impuestos", { params: { fechaIni, fechaFin, sucursal } });

export const getPdfPorCuf = (cuf) =>
  axios.get(`/api/reporte-impuestos/pdf/${encodeURIComponent(cuf)}`, { responseType: "blob" });

export const exportarExcel = ({ fechaIni, fechaFin, sucursal }) =>
  axios.get("/api/reporte-impuestos/exportar-excel", {
    params: { fechaIni, fechaFin, sucursal },
    responseType: "blob",
  });
